import { useState } from 'react';
import { Paper, TextField, useTheme } from '@mui/material';
import {
    ChatBubbleOutline,
    Close as CloseIcon,
    Minimize as MinimizeIcon,
    Send as SendIcon,
} from '@mui/icons-material';
import Box from '@/components/ui/Box/Box';
import IconButton from '@/components/ui/IconButton/IconButton';
import Typography from '@/components/ui/Typography/Typography';
import { useChat } from '@/providers/ChatProvider/ChatProvider';
import { styles } from './styles';

const ChatDock = () => {
    const theme = useTheme();
    const chat = useChat();
    const [draft, setDraft] = useState('');

    if (chat.minimized) {
        return (
            <Box sx={styles.minimizedBar(theme)} onClick={chat.restore}>
                <ChatBubbleOutline sx={{ color: 'white' }} fontSize="small" />
                <Typography sx={{ color: 'white', fontWeight: 600, fontSize: '14px' }}>
                    {chat.channel?.name ?? 'Chat'}
                </Typography>
            </Box>
        );
    }

    if (!chat.open) return null;

    return (
        <Paper sx={styles.dock(theme)} elevation={6}>
            <Box sx={styles.header(theme)}>
                <Typography sx={styles.title}>
                    {chat.channel?.name ?? 'Chat'}
                </Typography>
                <Box sx={styles.headerActions}>
                    <IconButton size="small" onClick={chat.minimize}>
                        <MinimizeIcon fontSize="small" />
                    </IconButton>
                    <IconButton size="small" onClick={chat.close}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </Box>
            </Box>
            <Box sx={styles.messages}>
                <ChatBubbleOutline sx={{ fontSize: 64, color: 'grey.300' }} />
                <Typography sx={{ mt: 1 }}>Chat connection not configured</Typography>
                <Typography variant="caption">
                    Channel: {chat.channel?.url ?? '—'}
                </Typography>
            </Box>
            <Box sx={styles.composer(theme)}>
                <TextField
                    fullWidth
                    size="small"
                    placeholder="Type a message"
                    value={draft}
                    onChange={(e) => setDraft(e.target.value)}
                />
                <IconButton color="primary" onClick={() => setDraft('')}>
                    <SendIcon />
                </IconButton>
            </Box>
        </Paper>
    );
};

export default ChatDock;
